var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',_vm._l((_vm.themes),function(scheme,name){return _c('v-btn',{key:name,staticStyle:{"margin":"0 5px"},style:({ backgroundColor: scheme.primary, color: '#fff' }),on:{"click":function($event){return _vm.setTheme(name)}}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }